<template>
  <div class="WorkersList">
    <VisitorInfo
      v-for="(worker, k) in workers"
      :key="k"
      :id="`worker-info-${k}`"
      :visitor="worker"
      :nationality="nationalities.find((item) => item.id === worker.personal.nationality_id)"
      :identification="identifications.find((item) => item.id === worker.personal.identification_id)"
      variant="success"
    >
      <tempplate v-if="worker.responsible === true" slot="headerExtraInfo">
        Ответственное лицо
      </tempplate>
      <template slot="menu">
        <b-dropdown class="pull-right" block style="z-index:10030">
          <template slot="button-content"><i class="glyphicon glyphicon-menu-hamburger"></i></template>
          <template slot="default">
            <b-dropdown-item
              @click="moveWorkerToVisitor(k)"
            >
              Удалить из заявки
            </b-dropdown-item>
            <b-dropdown-item
              @click="setResponsibleWorker(k)"
              v-if="worker.responsible === false || worker.responsible === undefined"
            >
              Назначить ответственным
            </b-dropdown-item>
            <b-dropdown-item
              @click="unsetResponsibleWorker(k)"
              v-else
            >
              Снять ответственность
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </template>
    </VisitorInfo>
  </div>
</template>

<script>
import VisitorInfo from './VisitorInfo'

/**
 * @class WorkersList
 * @property identifications Array Identification document type
 * @property nationalities Array Flags icons
 * @property workers Array Added to application workers
 * @property removeWorker Function Remove worker callback
 * @property setResponsibleWorker Function Set responsible worker callback
 * @property unsetResponsibleWorker Function Unset responsible worker callback
 */
export default {
  name: 'WorkersList',
  components: { VisitorInfo },
  props: {
    nationalities: {
      type: Array
    },

    identifications: {
      type: Array
    },

    workers: {
      type: Array
    },

    removeWorker: {
      type: Function
    },

    moveWorkerToVisitor: {
      type: Function
    },

    setResponsibleWorker: {
      type: Function
    },

    unsetResponsibleWorker: {
      type: Function
    }
  }
}
</script>
